/* istanbul ignore file */
// strip html content from a datas (ex: notes)
export function strip(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return (doc.body.textContent || "").replace(/\n+/g,'\n');
}